import { ManageCookies } from './components';
import { htmlDomains, manageCookies } from './reducers';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // Remove a paleta de colocar estilo do volto-block-style.
    // TODO: Provisiorio, foi a unica maneira que descobri para aplicar uma config antes de um addon.
    pluggableStylesBlocksWhitelist: ['none'],
    appExtras: [
      ...(config.settings.appExtras ?? []),
      {
        match: '',
        component: ManageCookies,
      },
    ],
  };

  config.addonReducers = {
    ...config.addonReducers,
    manageCookies: manageCookies,
    htmlDomains: htmlDomains,
  };

  return config;
};

export default applyConfig;
